import { createStoreContextItem } from '../Shared/StoreContextItem';
import { DisposableBase, type IInitializable } from '../Types';
import { action, observable, runInAction } from 'mobx';
import { FaceSdk } from 'econnect-face-rec-web';
import { debugLog } from './DebugLogStore';

export class FaceSdkStore extends DisposableBase implements IInitializable {
    async initialize() {
        await this.initializeFaceSdk();
    }

    @observable accessor faceSdk: FaceSdk | null = null;

    @action faceSdkSet = (sdkInstance: FaceSdk) => {
        this.faceSdk = sdkInstance;
    };

    @observable accessor sdkInitializing = false;

    @action setSdkInitializing = (value: boolean) => {
        this.sdkInitializing = value;
    };

    @observable accessor error: string | null = null;

    @action setError = (value: string | null) => {
        this.error = value;
    };

    private initializeFaceSdk = async () => {
        //const benchmarkSummaries = await runBenchmarks()
        this.setSdkInitializing(true);
        this.setError(null);

        try {
            // // Simplified SDK initialization for quicker startup for this example
            const sdkInstance = await FaceSdk.create({
                detectorSettings: { executorType: 'wasm' },
                landmarkSettings: { executorType: 'wasm' },
                qualitySettings: { executorType: 'wasm' },
                recognitionSettings: { executorType: 'wasm' },
            });

            debugLog.info('FaceSdk initialized successfully');
            console.log('FaceSdk initialized successfully.');

            runInAction(() => {
                this.faceSdkSet(sdkInstance);
                this.setSdkInitializing(false);
            });
        } catch (sdkError) {
            const errorMessage = sdkError instanceof Error ? sdkError.message : 'Unknown error initializing FaceSdk';
            debugLog.error(`FaceSdk init failed: ${errorMessage}`);
            this.setError(errorMessage);
        } finally {
            this.setSdkInitializing(false);
        }
    };

    dispose() {
        super.dispose();

        if (this.faceSdk) {
            this.faceSdk[Symbol.dispose]();
        }
        console.log('disposed.');
    }
}

export const FaceSdkStoreContextItem = createStoreContextItem<FaceSdkStore>(() => {
    return () => new FaceSdkStore();
});

// async function runBenchmarks() {
//     const fullTest = false;
//     const iterations = fullTest ? 4 : 10;
//     const warmup = fullTest ? 2 : 5;

//     const benchmark = new FaceSdkBenchmark(
//         [KnownModel.Recognition], //, KnownModel.Landmarks],
//         ['wasm'], //[KnownModel.Detection, KnownModel.Landmarks, KnownModel.Quality], // Models to test // Executors to test
//         './models', // Path to your .onnx models
//         iterations, // Iterations per test
//         warmup, // Warmup iteratisons
//         fullTest
//     );

//     try {
//         const summaries = await benchmark.runAllBenchmarks();
//         const summaryString = JSON.stringify(summaries, null, 2);

//         console.log('Benchmark Summaries:', summaryString);

//         summaries.forEach((summary) => {
//             if (summary.fastestExecutor) {
//                 console.log(
//                     `Fastest executor for ${summary.modelName}: ${summary.fastestExecutor} at ${summary.fastestTimeMs?.toFixed(2)} ms`
//                 );
//             } else {
//                 console.log(`No successful benchmarks for ${summary.modelName} to determine fastest executor.`);
//             }
//         });

//         const overallFastest = benchmark.getFastestExecutorOverall(summaries);
//         if (overallFastest && overallFastest.executor) {
//             console.log(
//                 `Overall fastest executor (based on normalized score, lower is better): ${
//                     overallFastest.executor
//                 } with score ${overallFastest.averageNormalizedScore?.toFixed(3)}`
//             );
//             console.log('Overall details:', JSON.stringify(overallFastest.details, null, 2));
//         } else {
//             console.log('Could not determine an overall fastest executor from the benchmark results.');
//         }

//         return summaries;
//     } catch (error) {
//         console.error('Error running benchmarks:', error);
//     }
// }
